import React, { useState } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { FaAngleRight, FaHome, FaSearch } from "react-icons/fa";
import defaultImg from "../../images/defaultImg.png"
import { FiSearch } from "react-icons/fi";
export default function Search() {
  const [menuClick, setMenuClick] = useState(false)
  const toggleMenu = () => {
    setMenuClick(!menuClick)
  }
  const closeMenu = () => {
    setMenuClick(false)
  }
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header Header="Search" toggleMenu={toggleMenu} menuClick={menuClick} />
          <div className="main-container">
            <div className="card main-card">
              <div className="card-body">
              <div className="col-md-9 mx-auto text-center">
                <h1 className="sub-head pb-1">Find Your Dream Job Now</h1>
                <p className="label-text mb-4"> 5 lakh+ jobs for you to explore</p>
                <div className="d-flex align-items-center gap-2 mb-5">
                  <div className="w-100">
                    <div className="input-group">
                      <span className="input-group-text text-body search_group_text">
                        <FiSearch />
                      </span>
                      <input
                        type="text"
                        className="form-control search_input search_job"
                        placeholder="Enter Skills / Designations / Companies  "
                      />
                      <button className="btn btn-search-custome"
                      >
                        Search
                      </button>

                    </div>
                  </div>
                </div>

                <div>
                  <div className="xilliSearchItems">
                    <a href="/dashboard/searchResults" className="Xilliitems">
                      <FaHome />  <span>Remote</span> <FaAngleRight />
                    </a>
                    <a href="/dashboard/searchResults" className="Xilliitems">
                      <FaHome />  <span>Remote</span> <FaAngleRight />
                    </a>
                    <a href="/dashboard/searchResults" className="Xilliitems">
                      <FaHome />  <span>Remote</span> <FaAngleRight />
                    </a>
                    <a href="/dashboard/searchResults" className="Xilliitems">
                      <FaHome />  <span>Remote</span> <FaAngleRight />
                    </a>
                    <a href="/dashboard/searchResults" className="Xilliitems">
                      <FaHome />  <span>Remote</span> <FaAngleRight />
                    </a>
                    <a href="/dashboard/searchResults" className="Xilliitems">
                      <FaHome />  <span>Remote</span> <FaAngleRight />
                    </a>
                    <a href="/dashboard/searchResults" className="Xilliitems">
                      <FaHome />  <span>Remote</span> <FaAngleRight />
                    </a>
                    <a href="/dashboard/searchResults" className="Xilliitems">
                      <FaHome />  <span>Remote</span> <FaAngleRight />
                    </a>
                    <a href="/dashboard/searchResults" className="Xilliitems">
                      <FaHome />  <span>Remote</span> <FaAngleRight />
                    </a>
                    <a href="/dashboard/searchResults" className="Xilliitems">
                      <FaHome />  <span>Remote</span> <FaAngleRight />
                    </a>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}